import React from 'react';
import { Icon } from '../../../../../../../../../ui-kit';
import { SelectedColorBlock, ArrowBlock, OptionsListElement, RelativeBlock } from '../../../Blocks/components/common/StyledEditables';

const BorderColor = ({ active, style }) =>
<RelativeBlock>
    <OptionsListElement>
      <span>
        <Icon name="border" color="white" size={18} />
        <SelectedColorBlock style={{ background: style.borderColor || 'transparent' }} />
      </span>
      <ArrowBlock
      active={active}
      name="arrowdown"
      color="white"
      size={12} />

    </OptionsListElement>
  </RelativeBlock>;


export default BorderColor;